import { FEEDBACK_REASON_LABEL } from '@platform/schema/feedback';

import type { FeedbackReason, FeedbackTally } from '@platform/schema/feedback';

/** The helpful rate as a percentage, or why there is none. */
export const helpfulShown = (feedback: FeedbackTally): string => {
  if (feedback.count === 0) return '—';
  if (feedback.helpfulRate === undefined) return 'Insufficient data';
  return `${String(Math.round(feedback.helpfulRate * 100))}%`;
};

/** Reasons by name, each with how often it was picked when that is known. */
export const reasonsShown = (
  reasons: readonly (
    FeedbackReason | { reason: FeedbackReason; count: number }
  )[],
): string =>
  reasons.length === 0
    ? '—'
    : reasons
        .map((one) =>
          typeof one === 'string'
            ? FEEDBACK_REASON_LABEL[one]
            : `${FEEDBACK_REASON_LABEL[one.reason]} (${String(one.count)})`,
        )
        .join(', ');

export const shownDate = (iso: string | undefined): string =>
  iso === undefined ? '—' : new Date(iso).toLocaleDateString();
